export const INBOX_LIMIT = 10;

export const ACTIVE_MODE = 'ACTIVE_MODE';
export const ARCHIVE_MODE = 'ARCHIVE_MODE';

export const InboxTypes = {
    OWN: 'OWN',
    STAR: 'STAR',
    ALL: 'ALL',
};

export const INBOX_TAB_HEIGHT = 51;

export const NEW_CONVERSATION_ID = 'new';
export const FORWARD_CONVERSATION_ID = 'forward';
